import paper from 'paper';
import { AnimationType } from 'types/enums';

class GuidelineManager {
  guidelineSVGs: any[];
  arrowSVGs: any[];
  constructor() {
    this.guidelineSVGs = [];
    this.arrowSVGs = [];
  }

  getGuidelineSVGs = (svgObj) => {
    const guideLineAmount = parseInt(svgObj.name.split('-')[1], 10);
    const guidelineSVGs: any = [];
    let currentGuidelineSVG: any = null;

    for (let i = 0; i < guideLineAmount; i++) {
      currentGuidelineSVG = paper.project.getItem({
        name: new RegExp(`(line|dot)-${i}`),
      });

      if (currentGuidelineSVG.name.match(/line/)) {
        currentGuidelineSVG.data = {
          coordinates: this.getGuidelineCoordinates(currentGuidelineSVG),
        };
      } else {
        currentGuidelineSVG.data = {
          x: currentGuidelineSVG.getBounds().center.x,
          y: currentGuidelineSVG.getBounds().center.y,
        };
      }

      guidelineSVGs.push(currentGuidelineSVG);
    }
    this.guidelineSVGs = guidelineSVGs;
  };

  // TODO: remove undefined checks on arrowSVG objects
  // when the arrows are added to all of the character SVGs
  getArrowSVGs(svgObj) {
    const arrowAmount = parseInt(svgObj.name.split('-')[1], 10);
    const arrowSVGs: any = [];
    let currentArrowSVG: any = null;

    for (let i = 0; i < arrowAmount; i++) {
      currentArrowSVG = paper.project.getItem({
        name: new RegExp(`arrow-${i}`),
      });

      if (currentArrowSVG) {
        currentArrowSVG.opacity = 0;
      }

      arrowSVGs.push(currentArrowSVG);
    }

    this.arrowSVGs = arrowSVGs;
  }

  showArrowSVG(index) {
    if (this.arrowSVGs[index]) {
      this.arrowSVGs[index].opacity = 1;
    }
  }

  hideArrowSVG(index) {
    if (this.arrowSVGs[index]) {
      this.arrowSVGs[index].opacity = 0;
    }
  }

  hideAllArrowSVGs() {
    this.arrowSVGs.forEach(function (arrowSVG) {
      if (arrowSVG) {
        arrowSVG.opacity = 0;
      }
    });
  }

  getGuidelineCoordinates(guideLineSVG, density = 1) {
    const coordinates: any = [];
    let currentPoint: any = null;

    for (
      let i = 0, len = Math.floor(guideLineSVG.length);
      i < len;
      i += density
    ) {
      currentPoint = guideLineSVG.getPointAt(i);
      coordinates.push({
        x: currentPoint.x,
        y: currentPoint.y,
      });
    }

    coordinates.push({
      x: guideLineSVG.getPointAt(guideLineSVG.length).x,
      y: guideLineSVG.getPointAt(guideLineSVG.length).y,
    });

    return coordinates;
  }

  isFrogJumpPath(pathIndex) {
    return (
      this.guidelineSVGs[pathIndex] &&
      this.guidelineSVGs[pathIndex].name.match(/frogJump/)
    );
  }

  isDotPath(pathIndex) {
    return this.guidelineSVGs[pathIndex]?.name.match(/dot/);
  }

  isContinuePath(pathIndex) {
    return this.guidelineSVGs[pathIndex]?.name.match(/continue/);
  }

  getDrawEndAnimationType(pathIndex) {
    const pathParams = this.getPathParams(pathIndex);

    if (pathParams && pathParams.animation) {
      if (pathParams.animation === AnimationType.BUMP) {
        return AnimationType.BUMP;
      }

      if (pathParams.animation === AnimationType.TOW) {
        return AnimationType.TOW;
      }
    }

    return null;
  }

  isBumpPath(pathIndex) {
    const pathParams = this.getPathParams(pathIndex);

    return (
      pathParams &&
      pathParams.animation &&
      pathParams.animation === AnimationType.BUMP
    );
  }

  getPathParams(pathIndex) {
    const regEx = /\{(.*)\}/;
    const match = regEx.exec(this.guidelineSVGs[pathIndex]?.name);

    if (match && match[0]) {
      return JSON.parse(match[0].replace(/'/g, '"'));
    } else {
      return null;
    }
  }

  getGuidelineCaption(pathIndex, isSpanish) {
    return this.getPathParams(pathIndex)
      ? this.getPathParams(pathIndex)[
          `${isSpanish ? 'captionSpanish' : 'caption'}`
        ]
      : '';
  }
}

export default GuidelineManager;
